<nz-card class="flow-card" nzTitle="Documents">
    <p class="flow-card__subtitle">Review the agreements below before continuing.</p>

    <nz-spin [nzSpinning]="loading">
        <div class="docs-sections">
            <section class="docs-section" *ngIf="starlinkDisclosures.length">
                <h4>Starlink Disclosures</h4>
                <div class="docs-content">
                    <p *ngFor="let d of starlinkDisclosures">{{ d }}</p>
                </div>
            </section>

            <section class="docs-section" *ngIf="dishDisclosures.length">
                <h4>Dish Disclosures</h4>
                <div class="docs-content">
                    <p *ngFor="let d of dishDisclosures">{{ d }}</p>
                </div>
            </section>
        </div>

        <form nz-form [formGroup]="docsForm" [nzLayout]="'vertical'" nzNoColon class="flow-form">
            <nz-form-item class="flow-form__item">
                <nz-form-control [nzValidateStatus]="docsForm.get('acknowledged')">
                    <label nz-checkbox formControlName="acknowledged">
                        I have read and understand the agreements above.
                    </label>
                    <nz-form-explain
                        *ngIf="docsForm.get('acknowledged')?.touched && docsForm.get('acknowledged')?.errors?.['required']">
                        You must acknowledge the agreements to continue.
                    </nz-form-explain>
                </nz-form-control>
            </nz-form-item>

            <div class="flow-actions flow-actions--trailing">
                <button nz-button nzType="primary" [disabled]="docsForm.invalid || loading" (click)="submit()">
                    Continue
                </button>
            </div>
        </form>
    </nz-spin>
</nz-card>